import type { ReactNode } from "react";
import { useAuth } from "../auth";

/** Supervisor-or-admin gate, for the reports. AdminOnly stays admin-only. */
export function ManagerOnlyView({ role, children }: { role: string | undefined; children: ReactNode }) {
  return role === "admin" || role === "supervisor" ? <>{children}</> : <p className="text-sm text-slate-500">Supervisors and admins only.</p>;
}

export function ManagerOnly({ children }: { children: ReactNode }) {
  const { me } = useAuth();
  return <ManagerOnlyView role={me?.user.role}>{children}</ManagerOnlyView>;
}

export const managerPage = (C: () => JSX.Element) => () => <ManagerOnly><C /></ManagerOnly>;
